module.exports = __webpack_public_path__ + "img/hero1.1054c928.png";